<template>
  <el-card class="box-card">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db + '/home-page' }"
        >Página home</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="$route.params.id"
        >Editando escritorio: {{ form.title }}</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else-if="form.title"
        >Nuevo escritorio: {{ form.title }}</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else>Nuevo escritorio</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <h2>{{ form.title }}</h2>
    <el-form @submit.native.prevent="submit" ref="form" label-position="top" id="form">
      <el-row type="flex" justify="space-between">
        <el-col :span="5">
          <el-form-item label="Título">
            <el-input
              v-model="form.title"
              type="text"
              placeholder="Título"
              name="title"
              id="title"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Icono">
            <el-input v-model="form.icon" :prefix-icon="form.icon"></el-input>
            <a
              :href="'/dashboard/' + $route.params.db + '/icons/'"
              target="_blank"
              class="link"
              >Iconos</a
            >
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="Tipo de escritorio">
            <select
              name="menu_id"
              class="select"
              :class="notification_id ? 'disabled' : false"
              v-model="form.template_id"
              @change="onChange($event.target.value)"
              :disabled="notification_id ? true : false"
            >
              <option value="0">Selecciona uno tipo de escritorio</option>
              <option v-for="(t, i) in templates" :key="i" :value="t.id">
                {{ t.template }}
              </option>
            </select>
          </el-form-item>
        </el-col>

        <el-col :span="2">
          <el-form-item label="Orden">
            <el-input
              v-model="form.order_row"
              type="text"
              placeholder="Orden"
              name="order"
              id="order"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label="¿Confirmación Comprendido?">
            <el-switch
              v-model="form.need_read_confirmation"
              :active-value="'1'"
              :inactive-value="'2'"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <app-modal-add-auth
      v-if="modalShow"
      :table="tableAuth"
      :data="idAuth"
    ></app-modal-add-auth>
    <el-card v-if="id && showEditPermisos">
      <el-button-group>
        <el-button type="warning" @click="addAuth">Editar permisos</el-button>
      </el-button-group>
      <el-button-group v-loading="loading">
        <el-button type="danger" @click="sendEmail" v-if="showEnviar"
          >Enviar por email</el-button
        >
        <el-tag type="success" v-if="showTxtEnviado != ''"
          >Notificación enviada el: {{ showTxtEnviado }}</el-tag
        >
      </el-button-group>
    </el-card>

    <br />
    <br />
    <template v-if="showTabla">
      <app-table-paginate
        :routeEdit="routeEdit"
        :tableQuery="tableDataAPI"
        :tableColumns="tableColumns"
        :table="tableDelete"
        :preview="preview"
        :search="true"
      ></app-table-paginate>
    </template>

    <app-notification-form
      v-if="showFormNotificaction"
      :tipeTemplate="form.template_id"
      :notification="notification"
      ref="notComp"
    ></app-notification-form>
    <br />
    <el-row>
      <el-col :span="24">
        <button
          v-if="this.showBottons"
          type="submit"
          class="el-button el-button--primary"
          form="form"
        >
          <span>{{ btn }}</span>
        </button>
        <el-button v-if="!showFormNotificaction" type="primary" @click="addNoti()"
          >Añadir notificación</el-button
        >
        <el-button v-if="!$route.params.section_id" @click="close()">Cancelar</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import notificationform from "@/components/Dashboard/home/notificationform";
import modalAddAuth from "@/components/Dashboard/Modals/addAuth";

import ApiService from "@/common/api.service";
import { INTRANET_URL } from "@/common/config";
import { mapGetters } from "vuex";

import {
  FECTH_TIPO_TEMPLATE_DESKTOP,
  FECTH_PAGINA_ACTIVA,
  FECTH_PAGE,
} from "@/store/actions.type";
import { SET_TIPO_TEMPLATE_DESKTOP } from "@/store/mutations.type";
import moment from "moment-timezone";

export default {
  name: "desktopForm",
  components: {
    "app-notification-form": notificationform,
    "app-table-paginate": tablaConPaginador,
    "app-modal-add-auth": modalAddAuth,
  },
  async created() {
    this.$route.params.id ? (this.showBottons = true) : false;
    this.$route.params.id ? (this.btn = "Editar") : (this.btn = "Crear");
    await this.getTemplates();

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      if (this.$route.params.notification_id) {
        this.tableAuth = "notifications";
        this.idAuth = this.$route.params.notification_id;
        this.notification_id = this.$route.params.notification_id;
        await this.mod();
        await this.addNoti();
        this.showEditPermisos = true;
      } else {
        this.tableAuth = "desktop";
        this.idAuth = await this.$route.params.id;
        await this.init();
      }
      this.routeEdit =
        "/dashboard/" +
        this.$route.params.db +
        "/home-page/edit/" +
        this.id +
        "/notification/" +
        this.form.template_id +
        "/";
      this.preview = INTRANET_URL + "/modulo/" + this.form.url + "/";
    }
    await this.$root.$on("closeModal", () => {
      this.closeModal();
    });
    await this.$root.$on("delete", (id) => {
      this.eliminarRegistroSeccion(id);
    });
  },
  beforeDestroy() {
    this.$root.$off("closeModal", () => {
      this.closeModal();
    });
    this.$root.$off("delete", (id) => {
      this.eliminarRegistroSeccion(id);
    });
  },
  data() {
    return {
      loading: false,
      showTxtEnviado: "",
      showEnviar: false,
      showEditPermisos: true,

      // show,s
      showTabla: false,
      showBottons: false,
      btnPreview: false,
      showFormNotificaction: false,
      modalShow: false,

      // modal
      tableAuth: false,
      idAuth: false,

      // form
      id: null,
      form: {
        title: "",
        template_id: 0,
        icon: null,
        order_row: null,
        need_read_confirmation: 0,
      },
      oldForm: {
        title: null,
        template_id: 0,
        icon: null,
        order_row: null,
        need_read_confirmation: 0,
      },
      templates: null,
      template: null,
      btn: null,
      errorTitle: false,

      // paginate
      tableData: false,
      routeEdit: false,
      tableColumns: [
        {
          label: "#ID",
          prop: "id",
        },
        {
          label: "Título",
          prop: "title",
        },
        {
          label: "Enlace",
          prop: "link",
        },
        {
          label: "Fecha publicación",
          prop: "date",
        },
      ],
      tableDelete: false,
      preview: false,

      // notification
      notification: false,
      notification_id: false,
    };
  },
  methods: {
    async sendEmail() {
      this.loading = true;
      const response = await ApiService.post("dashboard/notificaciones/mail", {
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.notification.id,
      });
      let fecha_enviado_por_email = moment().tz("Europe/Madrid").format("DD/MM/YY");
      let form = {
        enviado_por_email: "1",
        fecha_enviado_por_email,
      };
      const r = await ApiService.post("dashboard/editform", {
        table: "notifications",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: form,
        id: this.notification.id,
      });
      this.loading = false;
      this.showEnviar = false;
      this.showTxtEnviado = fecha_enviado_por_email;
    },
    async getTemplates() {
      await this.$store
        .dispatch(FECTH_TIPO_TEMPLATE_DESKTOP)
        .then((response) => (this.templates = response));
    },
    async init() {
      await this.getDesktop();
      await this.getDesktopCopy();
      await this.getContent();
    },
    async mod() {
      await this.getDesktop();
      await this.getNoti();
      await this.onChange(this.form.template_id);
    },
    async getDesktop() {
      const response = await ApiService.post("dashboard/table", {
        table: "desktop",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.id,
      });

      this.form = response.data;
    },
    async getDesktopCopy() {
      const response = await ApiService.post("dashboard/table", {
        table: "desktop",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.id,
      });

      this.oldForm = response.data;
    },
    async getContent() {
      const response = await ApiService.post("dashboard/setsectionshome", {
        table: "notifications",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.id,
      });
      if (response.data == "Algo ha fallado") {
        this.tableData = "Algo ha fallado";
      } else {
        this.tableData = await response.data;
        this.showTabla = true;
      }
      this.showMenu = true;
    },
    async getNoti() {
      const response = await ApiService.post("dashboard/table", {
        table: "notifications",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.notification_id,
      });
      if (response.data != "Algo ha fallado") {
        this.notification = response.data;
        if (this.notification.enviado_por_email == 0) {
          this.showEnviar = true;
          this.showTxtEnviado = "";
        } else {
          this.showEnviar = false;
          this.showTxtEnviado = moment(this.notification.fecha_enviado_por_email)
            .tz("Europe/Madrid")
            .format("DD/MM/YY");
        }
      }
    },
    async onChange(value) {
      if (!this.notification_id && this.id != null) {
        this.$confirm(
          "Está cambiado el tipo de escritorio. Este cambio afectará a todo el contenido de este escritorio. ¿Continuar?",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(() => {
            this.$message({
              type: "success",
              message:
                "Has cambiado el tiepo de escritorio, al guardar se harán efectivo el cambio. Después revisa tus contenidos.",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Se ha cancelado el borrado",
            });
            this.form.template_id = this.oldForm.template_id;
          });
      } else {
        await this.addNoti();
      }
    },
    addNoti() {
      this.showTabla = false;
      this.showFormNotificaction = true;
      this.statusToBreadCrud = true;
      this.showBottons = true;
      this.showEditPermisos = false;
    },
    async submit() {
      if (this.form.title == "" || this.form.title == null) {
        this.$message({
          type: "error",
          message: "El campo título es obligatorio",
        });
        return false;
      }
      if (this.form.template_id == 0) {
        this.$message({
          type: "error",
          message: "El campo Tipo de escritorio es obligatorio",
        });
        return false;
      }

      const response = await ApiService.post("dashboard/editform", {
        table: "desktop",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.$route.params.id,
      });
      let a = response.data;
      if (a) {
        if (this.showFormNotificaction && this.$refs.notComp.getErrors()) {
        } else {
          let message;
          this.id == null
            ? (message = "Se ha añadido la entrada con éxito")
            : (message = "Se ha modifcado la entrada con éxito");
          this.$notify({
            title: "Modificado",
            message: message,
            type: "success",
          });

          this.showMenu = true;
          this.id == null ? (this.id = parseInt(response.data)) : false;
          await this.emit(this.id);
          this.updateUsuarioPermisos();
          this.showFormNotificaction = false;
          this.notification_id = false;
          this.$root.$on("finishNotificationSave", () => {
            this.$router.replace(
              "/dashboard/" + this.$route.params.db + "/home-page/edit/" + this.id
            );

            this.init();
          });
        }
      } else {
        this.$notify.error({
          title: "Fallo",
          message: "Ago ha fallodo y no se ha modificado la entrada",
        });
      }
    },
    async emit(id) {
      await this.$root.$emit("saveContent", id);
    },
    async eliminarRegistroSeccion(id) {
      this.showTabla = false;
      const response = await ApiService.post("dashboard/delete", {
        table: "notifications",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id,
      });
      this.deleterow = await response.data;
      let dn_id = await this.tableData.map((r) => {
        if (id == r.id) {
          return r.dn_id;
        }
      });
      await ApiService.post("dashboard/delete", {
        table: "desktop_notificactions",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: dn_id,
      });
      this.$message({
        type: "success",
        message: "Se ha eliminado correctamente",
      });
      this.showFormNotificaction = false;
      await this.getContent();
      this.showTabla = true;
    },
    async close() {
      await this.$router.replace("/dashboard/" + this.$route.params.db + "/home-page");
    },

    async updateUsuarioPermisos() {
      // busco los usuarios con permiso admin
      await ApiService.post("admin/users", {
        token: localStorage.getItem("token"),
        project: localStorage.getItem("table"),
      }).then((r) => {
        r.data.map((e) => {
          console.log(e);
          if (e.level == "admin") {
            ApiService.post("admin/user-access", {
              token: localStorage.getItem("token"),
              project: localStorage.getItem("table"),
              id: e.id,
            }).then((response) => {
              let access_tables = response.data.access_tables;
              let access_components = JSON.parse(response.data.access_components);
              let gestor_usuarios = response.data.gestor_usuarios;
              let value = access_components[0]["value"];
              value.push(this.id.toString());
              access_components[0]["value"] = value;

              ApiService.post("admin/update-user-access", {
                token: localStorage.getItem("token"),
                project: localStorage.getItem("table"),
                id: e.id,
                access_tables: access_tables,
                access_components: JSON.stringify(access_components),
                gestor_usuarios: gestor_usuarios,
              });
            });
          }
        });
      });
    },
    addAuth(table) {
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
    },
  },
  computed: {
    tableDataAPI() {
      return this.tableData;
    },
  },
};
</script>
<style>
.disabled {
  background-color: #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/home/form.vue